﻿import { Alert, Table, Typography } from 'antd';
import type { QueryResult } from '../../../types/survey-analytics.types';

function formatCell(cell: any) {
  if (!cell || cell.state !== 'VALUE') return '—';
  return typeof cell.value === 'number' ? cell.value.toLocaleString('pt-BR') : String(cell.value);
}

export function PivotTable({ result, loading, error }: { result?: QueryResult; loading?: boolean; error?: Error | null }) {
  if (error) return <Alert type="error" message="Não foi possível calcular a pivot" description={error.message} />;
  if (!result) return <Alert type="info" message="Escolha dimensão e medidas para calcular uma tabela pivot." />;
  const measure = result.measures[0];
  const columns = [
    { title: 'Opção', dataIndex: 'label', key: 'label', fixed: 'left' as const },
    ...result.groups.map(group => ({ title: `${group.label} · base ${formatCell(group.base)}`, key: group.key, render: (_: unknown, row: any) => formatCell(row.cells.find((cell: any) => cell.groupKey === group.key)?.measures?.[measure]) })),
  ];
  return (
    <div>
      {result.warnings.map(warning => <Alert key={warning.code} type="warning" showIcon message={warning.message} style={{ marginBottom: 8 }} />)}
      <Typography.Text type="secondary">Privacidade: {result.privacyPolicy}. Base total: {formatCell(result.totals.base)}</Typography.Text>
      <Table rowKey={(row) => row.optionKey ?? row.label} loading={loading} size="small" columns={columns} dataSource={result.rows} pagination={false} scroll={{ x: true }} />
    </div>
  );
}
export default PivotTable;
